/* eslint-disable vue/multi-word-component-names */
import Vue from 'vue';

// SIFFLETIFY
import SButton from '@/components/SButton/SButton.vue';
import SSplitButton from '@/components/SSplitButton/SSplitButton.vue';
import SIcon from '@/components/SIcon.vue';
import SLabel from '@/components/SLabel.vue';
import SAccordion from '@/components/SAccordion/SAccordion.vue';
import SCard from '@/components/SCard/SCard.vue';
import SModal from '@/components/SModal.vue';
import SCardToggle from '@/components/SCardToggle.vue';
import SMenuButton from '@/components/SMenuButton/SMenuButton.vue';
import SThreeDotMenu from '@/components/SThreeDotMenu.vue';
import SSwitchAccordion from '@/components/SSwitchAccordion/SSwitchAccordion.vue';

// COMMON
import TreeSelect from '@riophae/vue-treeselect';
import SHtmlView from '@/components/SHtmlView/SHtmlView.vue';
import Tag from '@/components/tags/Tag.vue';
import Tags from '@/components/tags/Tags.vue';
import Term from '@/components/terms/Term.vue';
import Terms from '@/components/terms/Terms.vue';
import HealthDot from '@/components/icons/Health-Dot.vue';
import HealthDots from '@/components/icons/Health-Dots.vue';
import QualityStatus from '@/components/quality-status/Quality-Status.vue';
import Severity from '@/components/Severity.vue';
import PlatformIcon from '@/components/icons/Platform-Icon.vue';
import DateTooltip from '@/components/date-tooltip/Date-Tooltip.vue';
import ModalDialog from '@/components/modal-dialog/Modal-Dialog.vue';
import ConfirmationDialog from '@/components/confirmation-dialog/Confirmation-Dialog.vue';
import Avatar from '@/components/avatar/Avatar.vue';
import SqlDialog from '@/components/sql-dialog/Sql-Dialog.vue';
import EntityPreviewCard from '@/components/cards/entity-preview-card/Entity-Preview-Card.vue';
import RuleCategoryCard from '@/components/cards/rule-category-card/Rule-Category-Card.vue';
import SNotifications from '@/components/SNotifications/SNotifications.vue';
import DataTableGenericPlaceholder from '@/components/placeholders/Data-Table-Generic-Placeholder.vue';
import NoDataAvailablePlaceholder from '@/components/placeholders/NoDataAvailablePlaceholder.vue';
import Bookmark from '@/components/bookmark/Bookmark.vue';
import DataSourcePlaceholder from '@/components/placeholders/Data-Source-Placeholder.vue';
import FilterReset from '@/components/filter-reset/Filter-Reset.vue';
import NavigationDrawerItem from '@/components/navigation-drawer/Navigation-Drawer-Item.vue';
import Logo from '@/components/logo/Logo.vue';
import TableIcon from '@/components/icons/Table-Icon.vue';
import IngestionTypeIcon from '@/components/icons/Ingestion-Type-Icon.vue';
import Shortcuts from '@/components/shortcuts/Shortcuts.vue';
import PositionDot from '@/components/icons/Position-Dot.vue';
import ExternalDescription from '@/components/external-descriptions/External-Description.vue';
import ExternalDescriptions from '@/components/external-descriptions/External-Descriptions.vue';
import FieldsSearchMatch from '@/components/fields-search-match/Fields-Search-Match.vue';
import EmptyDataPlaceholder from '@/components/placeholders/Empty-Data-Placeholder.vue';

// NESTED FIELDS
import NestedSheet from '@/components/nested-sheet/Nested-Sheet.vue';
import NestedSheetSimpleTable from '@/components/nested-sheet/Nested-Sheet-Simple-Table.vue';
import TreeNestedSelector from '@/components/selectors/Tree-Nested-Selector/Tree-Nested-Selector-Legacy.vue';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

// APP
import ThemeToggle from '@/components/theme-toggle/Theme-Toggle.vue';
import SearchBar from '@/components/search-bar/Search-Bar.vue';
import Breadcrumb from '@/components/breadcrumb/Breadcrumb.vue';

// CATALOG
import CatalogSearch from '@/components/catalog/Catalog-Search.vue';
import CatalogSort from '@/components/catalog/Catalog-Sort.vue';
import CatalogResults from '@/components/catalog/Catalog-Results.vue';
import CatalogFilters from '@/components/catalog/Catalog-Filters.vue';
import CatalogResultsCard from '@/components/catalog/Catalog-Results-Card.vue';

// ASSETS
import AssetOverviewDetail from '@/components/asset/overview/Asset-Overview-Detail.vue';
import AssetOverviewTransformation from '@/components/asset/overview/Asset-Overview-Transformation.vue';
import AssetOverviewSchema from '@/components/asset/overview/Asset-Overview-Schema.vue';
import AssetPreview from '@/components/asset/preview/Asset-Preview.vue';

// MONITORS
import MonitorsResultsPlaceholder from '@/components/monitors/Monitors-Results-Placeholder.vue';
import MonitorsEdit from '@/components/monitors/Monitors-Edit.vue';
import MonitorsYamlModal from '@/components/monitors/Monitors-Yaml-Modal.vue';

// INCIDENTS / ISSUE
import IncidentStatus from '@/components/incidents/Incident-Status.vue';

// LINEAGE
import LineagePanel from '@/components/lineage/Lineage-Panel.vue';

// CONDITIONAL RULES
import SuggestionsCard from '@/components/cards/suggestions-card/Suggestions-Card.vue';

// SMART REGEX

Vue.component('SButton', SButton);
Vue.component('SSplitButton', SSplitButton);
Vue.component('SIcon', SIcon);
Vue.component('SLabel', SLabel);
Vue.component('SCard', SCard);
Vue.component('SAccordion', SAccordion);
Vue.component('SSwitchAccordion', SSwitchAccordion);
Vue.component('SModal', SModal);
Vue.component('SCardToggle', SCardToggle);
Vue.component('SMenuButton', SMenuButton);
Vue.component('SThreeDotMenu', SThreeDotMenu);
Vue.component('SHtmlView', SHtmlView);
Vue.component('DataSourcePlaceholder', DataSourcePlaceholder);
Vue.component('EmptyDataPlaceholder', EmptyDataPlaceholder);
Vue.component('TableIcon', TableIcon);
Vue.component('IngestionTypeIcon', IngestionTypeIcon);
Vue.component('NavigationDrawerItem', NavigationDrawerItem);
Vue.component('Logo', Logo);
Vue.component('ThemeToggle', ThemeToggle);
Vue.component('FilterReset', FilterReset);
Vue.component('SearchBar', SearchBar);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('TreeNestedSelector', TreeNestedSelector);
Vue.component('TreeSelect', TreeSelect);
Vue.component('NestedSheet', NestedSheet);
Vue.component('NestedSheetSimpleTable', NestedSheetSimpleTable);
Vue.component('Tag', Tag);
Vue.component('Tags', Tags);
Vue.component('Term', Term);
Vue.component('Terms', Terms);
Vue.component('HealthDot', HealthDot);
Vue.component('HealthDots', HealthDots);
Vue.component('EntityPreviewCard', EntityPreviewCard);
Vue.component('QualityStatus', QualityStatus);
Vue.component('Severity', Severity);
Vue.component('PlatformIcon', PlatformIcon);
Vue.component('DateTooltip', DateTooltip);
Vue.component('ModalDialog', ModalDialog);
Vue.component('ConfirmationDialog', ConfirmationDialog);
Vue.component('Avatar', Avatar);
Vue.component('SqlDialog', SqlDialog);
Vue.component('CatalogSearch', CatalogSearch);
Vue.component('CatalogSort', CatalogSort);
Vue.component('CatalogResults', CatalogResults);
Vue.component('CatalogFilters', CatalogFilters);
Vue.component('IncidentStatus', IncidentStatus);
Vue.component('LineagePanel', LineagePanel);
Vue.component('MonitorsResultsPlaceholder', MonitorsResultsPlaceholder);
Vue.component('MonitorsEdit', MonitorsEdit);
Vue.component('MonitorsYamlModal', MonitorsYamlModal);
Vue.component('PositionDot', PositionDot);
Vue.component('ExternalDescription', ExternalDescription);
Vue.component('ExternalDescriptions', ExternalDescriptions);
Vue.component('FieldsSearchMatch', FieldsSearchMatch);
Vue.component('CatalogResultsCard', CatalogResultsCard);
Vue.component('RuleCategoryCard', RuleCategoryCard);
Vue.component('SNotifications', SNotifications);
Vue.component('DataTableGenericPlaceholder', DataTableGenericPlaceholder);
Vue.component('NoDataAvailablePlaceholder', NoDataAvailablePlaceholder);
Vue.component('Bookmark', Bookmark);
Vue.component('Shortcuts', Shortcuts);
Vue.component('AssetOverviewDetail', AssetOverviewDetail);
Vue.component('AssetOverviewTransformation', AssetOverviewTransformation);
Vue.component('AssetOverviewSchema', AssetOverviewSchema);
Vue.component('AssetPreview', AssetPreview);
Vue.component('SuggestionsCard', SuggestionsCard);
